import script from "./CreateEntityDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateEntityDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__